import { useCallback } from 'react';

import { ANALYTICS_SOURCE, PEOPLE_AND_AGENTS_ROW_ACTION_SUBJECT_ID } from '../../analytics.ts';
import { useTwgAnalyticsEvents } from '../../useTwgAnalyticsEvents.ts';
import type { RankedPagePersonOrAgent } from '../../utils/rankPagePeopleAndAgents.ts';

export const usePersonProfileNavigation = (
	accountId: string,
	primaryRelationship: RankedPagePersonOrAgent['primaryRelationship'],
): (() => void) => {
	const { createAnalyticsEvent } = useTwgAnalyticsEvents();

	return useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: PEOPLE_AND_AGENTS_ROW_ACTION_SUBJECT_ID,
				source: ANALYTICS_SOURCE,
				// The relationship tells us whether readers open authors or mere viewers.
				// Deliberately no name or account id — this payload carries no personal data.
				attributes: { relationship: primaryRelationship },
			},
		}).fire();

		// Graph Store can omit the account ID. Record the press without opening a dead profile.
		if (!accountId) {
			return;
		}

		// The people route cannot resolve account IDs when their colons are percent-encoded.
		window.open(`/wiki/people/${accountId}?ref=confluence`, '_blank', 'noopener,noreferrer');
	}, [accountId, createAnalyticsEvent, primaryRelationship]);
};
